import { useEffect } from 'react'

import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Row, Span } from 'components'
import Select from 'components/Select'
import { COLORS, SPACING, TYPOGRAPHY } from 'utils'

import { ButtonPagination } from './components/ButtonPagination'

export interface TableFooterProps {
  rows?: any[]
  rowsPerPage: number
  page: number
  handleChangePage: any
  handleChangeRowsPerPage: any
  totalItems?: number
  disabled?: boolean
  typeFooter?: 'online' | 'offline'
  justifyContent?: 'center' | 'left'
  gridPercentage?: string
}

import { ContainerFooter, ContainerPagination, ContainerSelect } from './styles'

const MAX_ITEMS = 7
const MAX_LEFT = (MAX_ITEMS - 1) / 2

export const TableFooter = ({
  page,
  rows = [],
  rowsPerPage = 15,
  handleChangePage,
  handleChangeRowsPerPage,
  totalItems = null,
  typeFooter = 'online',
  disabled = false,
  justifyContent = 'center',
  gridPercentage = '15'
}: TableFooterProps) => {
  const listRowsPerPage = [
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '15', value: 15 }
  ]
  const pages = totalItems ? totalItems : Math.ceil(rows?.length / rowsPerPage)
  const maxFirst = Math.max(pages - (MAX_ITEMS - 1), 1)
  const first = Math.min(Math.max(page - MAX_LEFT, 1), maxFirst)

  useEffect(() => {
    if (typeFooter === 'online') {
      handleChangePage(1)
    } else {
      handleChangePage(0)
    }
  }, [rowsPerPage])

  return (
    <>
      {!disabled && (
        <>
          <ContainerFooter gridPercentage={gridPercentage}>
            <ContainerPagination justifyContent={justifyContent}>
              {typeFooter === 'online' ? (
                <>
                  <ButtonPagination
                    text=""
                    endIcon={<ChevronLeft />}
                    disabled={page === 1}
                    minWidth={'2rem'}
                    onClick={() => handleChangePage(page - 1)}
                    variantButton="text"
                  />
                  <Row>
                    {Array.from({ length: Math.min(MAX_ITEMS, pages) })
                      .map((_, index) => index + first)
                      .map((pageCurrent) => (
                        <ButtonPagination
                          key={pageCurrent}
                          minWidth={'2rem'}
                          marginLeft={'10px'}
                          marginRight={'10px'}
                          onClick={() => handleChangePage(pageCurrent)}
                          text={pageCurrent.toString()}
                          width="5px"
                          variantButton={
                            pageCurrent == page ? 'default' : 'text'
                          }
                        />
                      ))}
                    <ButtonPagination
                      text=""
                      minWidth={'2rem'}
                      startIcon={<ChevronRight />}
                      disabled={page === pages}
                      onClick={() => handleChangePage(page + 1)}
                      variantButton="text"
                    />
                  </Row>
                </>
              ) : (
                <>
                  <ButtonPagination
                    text=""
                    minWidth={'2rem'}
                    endIcon={<ChevronLeft />}
                    disabled={page + 1 === 1}
                    onClick={() => handleChangePage(page - 1)}
                    variantButton="text"
                  />
                  <Row>
                    {Array.from({ length: Math.min(MAX_ITEMS, pages) })
                      .map((_, index) => index + first)
                      .map((pageCurrent) => (
                        <ButtonPagination
                          key={pageCurrent}
                          minWidth={'2rem'}
                          marginLeft={'10px'}
                          marginRight={'10px'}
                          onClick={() => handleChangePage(pageCurrent - 1)}
                          text={pageCurrent.toString()}
                          width="5px"
                          variantButton={
                            pageCurrent == page + 1 ? 'default' : 'text'
                          }
                        />
                      ))}
                    <ButtonPagination
                      text=""
                      minWidth={'2rem'}
                      startIcon={<ChevronRight />}
                      disabled={page + 1 === pages}
                      onClick={() => handleChangePage(page + 1)}
                      variantButton="text"
                    />
                  </Row>
                </>
              )}
            </ContainerPagination>
            <ContainerSelect>
              <Span
                text="Itens por página: "
                color={COLORS.black}
                fontSize={TYPOGRAPHY.bodySize16}
              />
              <Select
                listOptions={listRowsPerPage}
                labelMenu="label"
                valueMenu="value"
                onChange={handleChangeRowsPerPage}
                marginLeft={SPACING.spacing10}
                disableUnderline={true}
                value={rowsPerPage}
                marginTop="-1.3rem"
              />
            </ContainerSelect>
          </ContainerFooter>
        </>
      )}
    </>
  )
}
